(function () {
  'use strict';

  var mobileSky = window.matchMedia('(max-width: 749px)');

  function fitSky() {
    var sky = document.querySelector('.odyssee-sky-bg');
    if (!sky) return;
    if (!mobileSky.matches) {
      sky.style.top = '';
      sky.style.bottom = '';
      sky.style.height = '';
      return;
    }
    sky.style.top = '-80px';
    sky.style.bottom = 'auto';
    sky.style.height = 'calc(100lvh + 160px)';
  }

  fitSky();
  mobileSky.addEventListener('change', fitSky);
  window.addEventListener('orientationchange', fitSky);

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function mount(canvas) {
    if (!canvas || canvas.dataset.odysseeMeteorsReady === 'true') return;
    const ctx = canvas.getContext('2d', { alpha: true });
    if (!ctx) return;

    canvas.dataset.odysseeMeteorsReady = 'true';

    const host = canvas.parentElement || document.body;
    const shooting = [];
    let width = 0;
    let height = 0;
    let dpr = 1;
    let lastSpawn = 0;
    let nextSpawn = 500;
    let lastTs = 0;
    let raf = 0;
    let running = true;

    function resize() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      width = host.clientWidth || window.innerWidth;
      height = host.clientHeight || window.innerHeight;
      canvas.width = Math.round(width * dpr);
      canvas.height = Math.round(height * dpr);
      canvas.style.width = `${width}px`;
      canvas.style.height = `${height}px`;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function spawn(companion) {
      const fromRight = Math.random() > 0.45;
      const speed = 480 + Math.random() * 260;
      shooting.push({
        x: fromRight ? width * (0.28 + Math.random() * 0.78) : width * Math.random() * 0.42,
        y: height * (companion ? 0.08 : 0.02 + Math.random() * 0.7),
        vx: (fromRight ? -1 : 1) * speed,
        vy: speed * (0.32 + Math.random() * 0.28),
        life: 0,
        max: 0.75 + Math.random() * 0.4,
        len: (companion ? 70 : 130) + Math.random() * 90,
      });

      if (!companion && Math.random() > 0.62) spawn(true);
    }

    function draw(dt, now) {
      if (now - lastSpawn > nextSpawn && shooting.length < 3) {
        spawn(false);
        lastSpawn = now;
        nextSpawn = 1400 + Math.random() * 1600;
      }

      for (let i = shooting.length - 1; i >= 0; i -= 1) {
        const s = shooting[i];
        s.life += dt;
        s.x += s.vx * dt;
        s.y += s.vy * dt;

        const fade = 1 - s.life / s.max;
        if (fade <= 0 || s.y > height + 40) {
          shooting.splice(i, 1);
          continue;
        }

        const angle = Math.atan2(s.vy, s.vx);
        const tailX = s.x - Math.cos(angle) * s.len;
        const tailY = s.y - Math.sin(angle) * s.len;
        const grad = ctx.createLinearGradient(tailX, tailY, s.x, s.y);
        grad.addColorStop(0, 'rgba(232, 190, 96, 0)');
        grad.addColorStop(0.5, `rgba(232, 190, 96, ${0.22 * fade})`);
        grad.addColorStop(0.84, `rgba(255, 226, 150, ${0.8 * fade})`);
        grad.addColorStop(1, `rgba(255, 248, 225, ${fade})`);

        ctx.lineCap = 'round';
        ctx.strokeStyle = grad;
        ctx.lineWidth = 2.2;
        ctx.beginPath();
        ctx.moveTo(tailX, tailY);
        ctx.lineTo(s.x, s.y);
        ctx.stroke();

        ctx.beginPath();
        ctx.fillStyle = `rgba(255, 250, 232, ${0.95 * fade})`;
        ctx.arc(s.x, s.y, 1.7, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    function tick(ts) {
      if (!running) return;
      if (!canvas.isConnected) {
        running = false;
        return;
      }

      if (!lastTs) lastTs = ts;
      const dt = Math.min(0.05, (ts - lastTs) / 1000);
      lastTs = ts;

      ctx.clearRect(0, 0, width, height);
      if (!document.hidden) draw(dt, ts);
      raf = requestAnimationFrame(tick);
    }

    resize();
    window.addEventListener('resize', resize);
    raf = requestAnimationFrame(tick);
  }

  function boot() {
    document.querySelectorAll('canvas[data-odyssee-meteors]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
